export default __webpack_public_path__ + "static/GT-Walsheim-Bold-e9a3833e5c03fb2f2ef9cdcadebf5d77.woff";